module.exports = require("markdown-it-link-attributes");